export default function MapLoader() {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap);
    } else {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src =
        "https://webapi.amap.com/maps?v=1.4.15&key=554481b4d81d2abc7e4ff42a28032d2e&plugin=AMap.ToolBar,AMap.AdvancedInfoWindow,AMap.PlaceSearch,AMap.Autocomplete";
      script.onerror = reject;
      document.head.appendChild(script);
    }
    window.initAMap = () => {
      resolve(window.AMap);
    };
  });
}



// WEBPACK FOOTER //
// ./src/util/AMap.js